import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import AuthLayout from 'layout/AuthLayout';

import ResetPassword from 'pages/auth/ResetPasswordPage.jsx';
import AccountEnroll from 'pages/auth/AccountEnrollPage.jsx';
import LoginPage from 'pages/auth/LoginPage.jsx';

export default () => (
  <AuthLayout>
    <Suspense fallback={null}>
      <Switch>
        <Route
          name="ResetPassword"
          path="/reset-password/:token"
          component={ResetPassword}
        />
        <Route
          name="AccountEnroll"
          path="/account/enroll/:token"
          component={AccountEnroll}
        />
        <Route exact name="Login" path="/login" component={LoginPage} />
      </Switch>
    </Suspense>
  </AuthLayout>
);
